var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_5124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.2499V15.1059C2.25 9.71713 6.57656 5.26869 11.9653 5.24994C13.2486 5.24537 14.5202 5.4942 15.7071 5.98213C16.8941 6.47007 17.973 7.18753 18.882 8.09336C19.7911 8.99918 20.5124 10.0756 21.0045 11.2607C21.4967 12.4459 21.75 13.7166 21.75 14.9999V17.2499C21.75 17.4489 21.671 17.6396 21.5303 17.7803C21.3897 17.9209 21.1989 17.9999 21 17.9999H3C2.80109 17.9999 2.61032 17.9209 2.46967 17.7803C2.32902 17.6396 2.25 17.4489 2.25 17.2499Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25V8.25",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18L15.75 9.75",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13.5H21.6356",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38037 13.5H5.25006",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_5124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--sidebar-text-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuIndex);
export default __webpack_public_path__ + "static/media/ic-menu-index.aea13641d66b54cbccd03c41aca16468.svg";
export { ForwardRef as ReactComponent };